import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import MatchReportsPage from './MatchReportsPage';
import AthleteMatchHistoryPage from './AthleteMatchHistoryPage';

// MRV2.1 — Match Reports V2 is Admin/Staff-facing only (per Implementation
// Approval). Player/Parent keep the legacy per-athlete Match Reports page
// unchanged — V2 never broadens their access, it only replaces the
// Admin/Staff experience at the same nav entry point.
const MatchReportsEntry = () => {
  const { user } = useAuth();
  const isStaff = user?.role === 'Admin' || user?.role === 'Staff';
  return isStaff ? <AthleteMatchHistoryPage /> : <MatchReportsPage />;
};

export default MatchReportsEntry;
